"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
var _toConsumableArray2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LogQuery',
  data: function data() {
    return {
      loading: false,
      logList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 日志服务单元
      unitOptions: [{
        label: '充电宝',
        value: 'newbao'
      }, {
        label: '充电桩',
        value: 'zhuang'
      }],
      // 日志查询级别
      levelOptions: [{
        label: '系统不可用',
        value: 'emerg'
      }, {
        label: '需要立即采取行动',
        value: 'alert'
      }, {
        label: '严重错误',
        value: 'crit'
      }, {
        label: '错误',
        value: 'err'
      }, {
        label: '警告',
        value: 'warning'
      }, {
        label: '正常但重要的事件',
        value: 'notice'
      }, {
        label: '信息性消息',
        value: 'info'
      }, {
        label: '调试信息',
        value: 'debug'
      }],
      queryParams: {
        unit: 'zhuang',
        // 默认充电桩
        level: 'info',
        // 默认 info 级别
        since: '',
        // 开始日期
        until: '',
        // 结束日期
        grepString: '' // 过滤字符串
      },
      startTime: '',
      // 开始时间
      endTime: '',
      // 结束时间（自动计算）
      dateRange: [],
      // 日期范围选择器绑定值（已废弃，保留以兼容旧代码）
      isAutoRefresh: false,
      // 是否自动刷新
      refreshInterval: 10,
      // 刷新间隔（秒）
      refreshTimer: null,
      // 定时器
      maxLogCount: 1000,
      // 最大保留日志条数
      duplicateLogs: new Set() // 存储重复的日志内容
    };
  },
  computed: {
    /**
     * 检查日志是否重复
     */
    isDuplicateLog: function isDuplicateLog() {
      var _this = this;
      return function (content) {
        return _this.duplicateLogs.has(content);
      };
    }
  },
  created: function created() {
    this.setDefaultDateRange();
    this.fetchData();
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
  methods: {
    /**
     * 设置默认时间范围为最近 5 分钟
     */
    setDefaultDateRange: function setDefaultDateRange() {
      var now = new Date();
      var fiveMinutesAgo = new Date(now.getTime() - 5 * 60 * 1000);

      // 格式化为 yyyy-MM-dd HH:mm:ss
      var formatDateTime = function formatDateTime(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      };

      // 设置查询参数
      this.queryParams.since = formatDateTime(fiveMinutesAgo);
      this.queryParams.until = formatDateTime(now);

      // 设置开始时间和结束时间
      this.startTime = formatDateTime(fiveMinutesAgo);
      this.endTime = formatDateTime(now);
    },
    /**
     * 处理开始时间变化
     */
    handleStartTimeChange: function handleStartTimeChange(value) {
      if (!value) {
        this.queryParams.since = '';
        this.queryParams.until = '';
        this.endTime = '';
        return;
      }
      var startTime = new Date(value);
      var calculatedEndTime = new Date(startTime.getTime() + 15 * 60 * 1000);
      var formatDateTime = function formatDateTime(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      };
      var formattedEndTime = formatDateTime(calculatedEndTime);

      // 更新开始和结束时间
      this.queryParams.since = value;
      this.queryParams.until = formattedEndTime;
      this.endTime = formattedEndTime;
    },
    /**
     * 处理日期变化
     */
    handleDateChange: function handleDateChange(value) {
      if (value && value.length === 2 && value[0] && value[1]) {
        var start = new Date(value[0]).getTime();
        var end = new Date(value[1]).getTime();
        var diffMinutes = (end - start) / (1000 * 60);

        // 检查时间范围是否超过 15 分钟
        if (diffMinutes > 15) {
          this.$message.warning('查询时间范围不能超过 15 分钟');
          // 重置为默认时间范围
          this.setDefaultDateRange();
          return;
        }
        this.queryParams.since = value[0];
        this.queryParams.until = value[1];
      } else {
        this.queryParams.since = '';
        this.queryParams.until = '';
      }
    },
    /**
     * 处理日期输入框的变化（实时监听用户输入）
     */
    handleDateInput: function handleDateInput(value) {
      var _this2 = this;
      if (value && value.length === 2 && value[0] && value[1]) {
        var start = new Date(value[0]);
        // const end = new Date(value[1])
        // const diffMinutes = (end - start) / (1000 * 60)

        // 如果两个时间相同，或者结束时间减去开始时间小于 1 分钟，说明用户只修改了开始时间
        // if (diffMinutes < 1 || Math.abs(diffMinutes) < 1) {
        // 自动设置结束时间为开始时间 + 15 分钟
        var calculatedEndTime = new Date(start.getTime() + 15 * 60 * 1000);
        var formatDateTime = function formatDateTime(date) {
          var year = date.getFullYear();
          var month = String(date.getMonth() + 1).padStart(2, '0');
          var day = String(date.getDate()).padStart(2, '0');
          var hours = String(date.getHours()).padStart(2, '0');
          var minutes = String(date.getMinutes()).padStart(2, '0');
          var seconds = String(date.getSeconds()).padStart(2, '0');
          return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
        };
        var formattedEndTime = formatDateTime(calculatedEndTime);

        // 更新日期选择器的值
        this.$nextTick(function () {
          _this2.dateRange = [value[0], formattedEndTime];
        });
        // }
      }
    },
    /**
     * 获取日志列表
     * @param {Boolean} isAppend 是否追加模式
     * @param {Boolean} isSilent 是否静默刷新（不显示 loading）
     */
    fetchData: function fetchData() {
      var _this3 = this;
      var isAppend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isSilent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // 只有非静默模式才显示 loading
      if (!isSilent) {
        this.loading = true;
      }
      // 处理日期范围参数
      var params = _objectSpread({
        page: this.currentPage,
        limit: this.pageSize
      }, this.queryParams);
      this.$get('agentapi/data_overview/overview_log_query', params).then(function (res) {
        var newList = res || [];
        if (isAppend && _this3.logList.length > 0) {
          // 追加模式：将新数据追加到列表头部（实时数据显示在前面）
          _this3.logList = [].concat((0, _toConsumableArray2.default)(newList), (0, _toConsumableArray2.default)(_this3.logList));
          // 限制最大条数，避免内存溢出
          if (_this3.logList.length > _this3.maxLogCount) {
            _this3.logList = _this3.logList.slice(0, _this3.maxLogCount);
          }
          // 检测并标记重复的日志
          _this3.markDuplicateLogs();
        } else {
          // 普通模式：替换旧数据
          _this3.logList = newList;
          // 清空重复标记
          _this3.duplicateLogs.clear();
        }

        // 只有非静默模式才关闭 loading
        if (!isSilent) {
          _this3.loading = false;
        }
      }).catch(function (err) {
        // 只有非静默模式才关闭 loading
        if (!isSilent) {
          _this3.loading = false;
        }
      });
    },
    /**
     * 分页
     */
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    /**
     * 处理开关变化
     */
    handleSwitchChange: function handleSwitchChange(value) {
      if (value) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    },
    /**
     * 查询
     */
    handleFilter: function handleFilter() {
      // 如果正在自动刷新，先停止
      if (this.isAutoRefresh) {
        this.stopAutoRefresh();
        // 关闭开关
        this.isAutoRefresh = false;
      }
      this.currentPage = 1;
      this.fetchData();
    },
    /**
     * 开启自动刷新
     */
    startAutoRefresh: function startAutoRefresh() {
      var _this4 = this;
      this.isAutoRefresh = true;
      // 设置最近 1 分钟的时间范围
      this.setOneMinuteRange();
      // 立即执行一次（静默模式，不显示 loading）
      this.fetchData(true, true);
      // 启动定时器，实时更新
      this.refreshTimer = setInterval(function () {
        // 实时更新最近 1 分钟的时间范围
        _this4.setOneMinuteRange();
        // 静默刷新，不显示 loading
        _this4.fetchData(true, true);
      }, this.refreshInterval * 1000);
      this.$message.success("\u5DF2\u5F00\u542F\u81EA\u52A8\u5237\u65B0\uFF0C\u95F4\u9694".concat(this.refreshInterval, "\u79D2"));
    },
    /**
     * 停止自动刷新
     */
    stopAutoRefresh: function stopAutoRefresh() {
      this.isAutoRefresh = false;
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
      this.$message.info('已停止自动刷新');
    },
    /**
     * 设置最近 1 分钟的时间范围
     */
    setOneMinuteRange: function setOneMinuteRange() {
      var now = new Date();
      var oneMinuteAgo = new Date(now.getTime() - 60 * 1000);
      var formatDateTime = function formatDateTime(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      };
      this.queryParams.since = formatDateTime(oneMinuteAgo);
      this.queryParams.until = formatDateTime(now);
      this.startTime = formatDateTime(oneMinuteAgo);
      this.endTime = formatDateTime(now);
    },
    /**
     * 重置查询条件
     */
    resetQuery: function resetQuery() {
      // 如果正在自动刷新，先停止
      if (this.isAutoRefresh) {
        this.stopAutoRefresh();
      }
      this.queryParams = {
        unit: 'zhuang',
        // 默认充电桩
        level: 'info',
        // 默认 info 级别
        grepString: '' // 重置过滤字符串
      };
      this.startTime = ''; // 重置开始时间
      this.endTime = ''; // 重置结束时间
      this.setDefaultDateRange(); // 重新设置默认时间范围
      this.currentPage = 1;
      this.fetchData();
    },
    /**
     * 标记重复的日志内容
     */
    markDuplicateLogs: function markDuplicateLogs() {
      var _this5 = this;
      var logCount = {};
      this.duplicateLogs.clear();

      // 统计每条日志出现的次数
      this.logList.forEach(function (log) {
        var content = log[0];
        logCount[content] = (logCount[content] || 0) + 1;
      });

      // 将出现超过一次的日志标记为重复
      Object.keys(logCount).forEach(function (content) {
        if (logCount[content] > 1) {
          _this5.duplicateLogs.add(content);
        }
      });
    }
  }
};